export const BITMOVIN_API_BASE_PATH = 'https://api.bitmovin.com/v1';
